var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgUserProfile = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.25 6.75C8.25 4.67893 9.92893 3 12 3C14.0711 3 15.75 4.67893 15.75 6.75C15.75 8.82107 14.0711 10.5 12 10.5C9.92893 10.5 8.25 8.82107 8.25 6.75ZM12 1.5C9.1005 1.5 6.75 3.8505 6.75 6.75C6.75 9.64949 9.1005 12 12 12C14.8995 12 17.25 9.64949 17.25 6.75C17.25 3.8505 14.8995 1.5 12 1.5ZM7.5 13.5C6.13427 13.5 4.80925 13.9815 3.81975 14.861C3.33132 15.2952 2.76956 15.9855 2.32893 16.701C1.9067 17.3866 1.5 18.247 1.5 19V21.75C1.5 22.1642 1.83579 22.5 2.25 22.5H21.75C22.1642 22.5 22.5 22.1642 22.5 21.75V19C22.5 18.247 22.0933 17.3866 21.6711 16.701C21.2304 15.9855 20.6687 15.2952 20.1803 14.861C19.1907 13.9815 17.8657 13.5 16.5 13.5H7.5ZM4.81629 15.9821C5.51461 15.3614 6.47879 15 7.5 15H16.5C17.5212 15 18.4854 15.3614 19.1837 15.9821C19.5392 16.2981 20.0114 16.8666 20.3938 17.4875C20.7946 18.1384 21 18.6921 21 19V21H3V19C3 18.6921 3.20536 18.1384 3.60616 17.4875C3.98855 16.8666 4.46081 16.2981 4.81629 15.9821Z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgUserProfile);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/user-profile.7cee0f9e8e4a36a734b971d9145bea3c.svg";